import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';

import { ModalContentComponent } from './modal-content.component';


@NgModule({
  declarations: [ModalContentComponent],
  imports: [CommonModule,
    FlexModule,
    MatIconModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [ModalContentComponent],
  entryComponents: [ModalContentComponent]
})
export class ModalContentModule { }
